
import config from "@/assets/config";
import menu_lateral from "@/assets/menu_lateral";
import routers from "@/assets/routes";
import acl from "@/assets/config_acl";
import { mx_maestros } from "@/mixins/maestros/mx_maestros";
import { common } from "@/mixins/common";

export default {
  name: "MenuLateral",
  mixins: [mx_maestros, common],
  beforeMount() {
    this.loadTargets();
  },
  mounted() {
    document.addEventListener("mouseleave", this.onDocumentMouseLeave);
    window.addEventListener("blur", this.onWindowBlur);
  },
  beforeDestroy() {
    document.removeEventListener("mouseleave", this.onDocumentMouseLeave);
    window.removeEventListener("blur", this.onWindowBlur);
    this.clearTimers();
  },
  data() {
    return {
      items: [],
      user_name: "",
      isExpanded: false,
      activeSubmenu: null,
      hoverTimeout: null,
      activationTimeout: null,
      submenuHovered: false,
      isLoading: true,
      hoverActivationOffset: 8,
      hoverActivationDelay: 150,
    };
  },
  methods: {
    clearTimers() {
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = null;
      }
      if (this.activationTimeout) {
        clearTimeout(this.activationTimeout);
        this.activationTimeout = null;
      }
    },

    closeDrawer() {
      this.clearTimers();
      this.submenuHovered = false;
      this.isExpanded = false;
      this.activeSubmenu = null;
      this.$emit('menu-expanded', false);
    },

    scheduleCloseDrawer() {
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
      }
      this.hoverTimeout = setTimeout(() => {
        this.closeDrawer();
      }, 150);
    },

    onMenuEnter() {
      clearTimeout(this.hoverTimeout);
    },

    onMenuMove(event) {
      if (this.isExpanded) return;
      const railEl = this.$refs.railMenu || event.currentTarget;
      const railRect = railEl.getBoundingClientRect();
      const distanceFromRight = railRect.right - event.clientX;
      const isPointerInsideRail = event.clientX >= railRect.left && event.clientX <= railRect.right;

      if (isPointerInsideRail && distanceFromRight > this.hoverActivationOffset) {
        if (!this.activationTimeout) {
          this.activationTimeout = setTimeout(() => {
            this.isExpanded = true;
            this.$emit('menu-expanded', true);
            this.activationTimeout = null;
          }, this.hoverActivationDelay);
        }
      } else if (this.activationTimeout) {
        clearTimeout(this.activationTimeout);
        this.activationTimeout = null;
      }
    },
    
    onMenuLeave() {
      if (this.activationTimeout) {
        clearTimeout(this.activationTimeout);
        this.activationTimeout = null;
      }
      this.scheduleCloseDrawer();
    },
    
    onSubmenuEnter() {
      clearTimeout(this.hoverTimeout);
      this.submenuHovered = true;
    },
    
    onSubmenuLeave() {
      this.submenuHovered = false;
      this.scheduleCloseDrawer();
    },

    onDocumentMouseLeave() {
      this.closeDrawer();
    },

    onWindowBlur() {
      this.closeDrawer();
    },
    
    handleItemClick(item) {
      if (item.items && item.items.length > 0) {
        if (this.activeSubmenu === item) {
          this.activeSubmenu = null;
        } else {
          this.activeSubmenu = item;
        }
      } else {
        this.goTo(item);
      }
    },
    
    isSubmenuActive(item) {
      if (!item.items) return false;
      return item.items.some(subItem => this.isActiveRoute(subItem.route));
    },

    async loadTargets() {
      try {
        this.isLoading = true;
        this.user_name = this.getStateCookie(config.cookie.username);
        let rules = this.$store.getters.getRules;
        let targets = this.$store.getters.getTargets;
        let objects = (await this.$axios.get(config.api.url + "acl_objetos")).data.info.map(obj => obj.id);

        for (let index = 0; index < menu_lateral.length; index++) {
          let menu = menu_lateral[index];
          
          if (menu.items) {
            let submenus = [];
            menu.items.forEach(submenu => {
              if (submenu.target && (targets.includes(submenu.target) || !objects.includes(submenu.target))) {
                submenus.push(submenu);
              }
            });
            
            if (submenus.length > 0) {
              menu.items = submenus;
              this.items.push(menu);
            }
          }
          else if (targets.includes(menu.target) || menu.target === "*") {
            this.items.push(menu);
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    goTo(item) {
      this.$router.push(item.route);
      this.closeDrawer();
    },

    isActiveRoute(route) {
      if (!route) return false;
      const currentPath = this.$route.path;
      if (currentPath === route) return true;

      const normalizedRoute = route.replace(/\/$/, '');
      const normalizedCurrent = currentPath.replace(/\/$/, '');

      if (normalizedCurrent === normalizedRoute) return true;

      if (normalizedRoute && normalizedRoute !== '/' && normalizedCurrent.startsWith(normalizedRoute + '/')) {
        const allRoutes = this.getAllMenuRoutes();
        const moreSpecificRoute = allRoutes.find(menuRoute => {
          const normalizedMenuRoute = menuRoute.replace(/\/$/, '');
          return normalizedMenuRoute !== normalizedRoute &&
            normalizedMenuRoute.startsWith(normalizedRoute) &&
            (normalizedCurrent === normalizedMenuRoute ||
              normalizedCurrent.startsWith(normalizedMenuRoute + '/'));
        });
        return !moreSpecificRoute;
      }
      return false;
    },

    getAllMenuRoutes() {
      const routes = [];
      this.items.forEach(item => {
        if (item.route) routes.push(item.route);
        if (item.items) {
          item.items.forEach(subItem => {
            if (subItem.route) routes.push(subItem.route);
          });
        }
      });
      return routes;
    },
  },
};
